module.exports = __webpack_public_path__ + "img/62.b1741802.svg";